const ACTION_LABELS = {
  order_view: 'View order',
  order_change_cancel: 'Change / cancel',
  order_need_help: 'Need help',
  order_track: 'Track order',
  order_invoice: 'Download invoice',
  order_delivery_details: 'Delivery details',
  order_cancel: 'Cancel order',
  order_address_change: 'Change address',
  order_complaint: 'Other complaint',
  order_delivery_issue: 'Delivery issue',
  order_payment_issue: 'Payment issue',
  order_product_issue: 'Product / order issue',
  order_other_complaint: 'Other complaint',
  order_delivery_help: 'Delivery help',
  order_change_date: 'Change delivery date',
  order_add_instructions: 'Add delivery instructions',
  order_wrong_address: 'Wrong address',
  order_rate: 'Rate order',
  order_return: 'Return / exchange',
  order_exchange: 'Exchange',
  return_damaged: 'Damaged on arrival',
  return_wrong_product: 'Wrong product',
  return_changed_mind: 'Changed mind',
  return_not_working: 'Product not working',
  main_menu: 'Main menu',
  talk_to_agent: 'Talk to agent',
  campaign_view_product: 'View product',
  campaign_buy_now: 'Buy now',
  campaign_ask_question: 'Ask a question',
  campaign_similar_products: 'Similar products',
  campaign_request_demo: 'Request demo',
  campaign_more_options: 'More options',
  campaign_current_offers: 'Current offers',
  campaign_check_availability: 'Check availability',
  campaign_sample_wholesale: 'Sample / wholesale',
  campaign_stop_promotions: 'Stop promotions',
  wholesale_check_status: 'Check status',
  wholesale_add_details: 'Add details',
  wholesale_contact_sales: 'Contact sales',
  wholesale_report_issue: 'Report issue',
  quotation_view: 'View quotation',
  quotation_accept: 'Accept & proceed',
  quotation_request_changes: 'Request changes',
  quotation_open_doc: 'Open quotation',
};

export default ACTION_LABELS;
